import { createSelector } from '@ngrx/store';
import { getPendingState } from '../store/store.selectors';
import { PendingStateInterface } from './pending.state';

export const getPendingStatus = createSelector(
  getPendingState,
  (state: PendingStateInterface) => state.isPending
);
